export default "__VITE_ASSET__qj1on8j9yOfH2extuZKCPg__"